export default "__VITE_ASSET__BNJRI5Iu__"